module.exports = __webpack_public_path__ + "static/img/5.6a98968f.png";